import { Toast } from 'antd-mobile';
import modStyl from './ChooseModal.module.scss'

import React, {FormEvent, useMemo, useState} from "react"

export type Value = {
  type: string;
  relation: string;
}
type Props = {
  onClose: ()=> void;
  onConfirm: (value: Value)=> void;
}

const ChooseModal: React.FC<Props> = ({onConfirm, onClose})=> {
  const [type, setType] = useState<string>()
  const [types] = useState(['患者签名', '见证人签名', '监护人签名'])

  const [relation, setRelation] = useState<string>()
  const [relations] = useState(['父母', '子女'])

  const [other, setOther] = useState('')

  const chaperonType = '监护人签名'

  const disabled = useMemo(()=> {
    // 选择监护人时
    if(type === chaperonType) {
      // 没有选择关系或输入关系
      if(!other && !relation) {
        return true
      }
    } else if(!type) {
      return true
    }
    return false
  }, [other, relation, type])

  const chooseType = (label: string)=> {
    setRelation(label)
    setOther('')
  }

  const chooseOther = ()=> {
    setRelation('')
  }

  const confirmControl = ()=> {
    if(!type) {
      Toast.info('请选择签名者类型')
      return
    }
    if(type === chaperonType) {
      if(!relation && !other) {
        Toast.info('请选择或输入患者关系')
        return
      }
    }
    onConfirm({
      type,
      relation: relation ? relation : other,
    })
  }

  return (
    <div className={modStyl.modal}>
      <div className={modStyl.inner}>
        <div className={modStyl.header}>请选择签名者类型</div>
        <div className={modStyl.main}>
          <ul>
            {
              types.map(label=> (
                <li onClick={()=> setType(label)} className={label === type ? modStyl.active : ''} key={label}>{label}</li>
              ))
            }
          </ul>
          {
            type === chaperonType && (
              <ul className={modStyl.relation}>
                {
                  relations.map(label=> (
                    <li onClick={()=> chooseType(label)} className={label === relation ? modStyl.activeChild : ''} key={label}>{label}</li>
                  ))
                }
                <li>
                  <input onFocus={chooseOther} onInput={({target}: FormEvent)=> setOther((target as HTMLInputElement).value)} value={other} type="text" maxLength={6} placeholder='请输入和患者关系'/>
                </li>
              </ul>
            )
          }
        </div>
        <div className={modStyl.footer}>
          <button disabled={disabled} onClick={confirmControl} type="button" className={modStyl.btn}>确定</button>
        </div>
        <button onClick={onClose} type="button" className={modStyl.close}>
          <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="192" height="192">
            <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
          </svg>
        </button>
      </div>
    </div>
  )
}

export default ChooseModal